import React, { useState, useEffect } from 'react'
import { Dialog, DialogContent, TextField } from '@material-ui/core';
import { List, ListItem, ListItemText, Switch } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import Header from '../Header';
import { useStore } from '../../Store'

const ListEditor = ({ group, onClose, open, sci, info }) => {
    const { shortlist, setShortlist } = useStore()
    const [list, setList] = useState([])
    const [filter, setFilter] = useState('')

    useEffect(() => {
        const members = (group.group in shortlist ? shortlist[group.group]
            : group.members.filter(item => item.info.shortlist === "1").map(item => { return item.id }))
        setList(members)
    }, [group, shortlist])

    const handleToggle = (id) => {
        if (list.includes(id)) {
            setList(list.filter(o => o !== id))
        } else {
            setList([...list, id])
        }
    }

    const handleClose = () => {
        const newList = { ...shortlist }
        newList[group.group] = list
        setShortlist(newList)
        onClose()
    }

    const match = (item) => {
        if (filter.length < 1) return false
        const regex= new RegExp(filter, 'i')
        return item.info.sci.match(regex) || item.info.com.match(regex)
    }

    return (
        <Dialog open={open} fullScreen>
            <Header title={`Lijst ${group.group}`} backAction={handleClose} />
            <DialogContent>
                <Alert severity="info">
                    Geef aan welke soorten er getoond moet worden op het telformulier
                    binnen de groep <i>{group.group}</i>
                </Alert>
                {group.show || <TextField value={filter} variant="standard" fullWidth onChange={(e) => { setFilter(e.target.value) }} />}
                <List dense={true} component="nav" aria-label="soorten" style={{ marginBottom: '57px' }}>
                    {group.members.filter(item => group.show || (!group.show && filter.length === 0 && list.includes(item.id)) || match(item)).map((item, i) => (
                        <ListItem button id={item.id} key={item.id} onClick={() => { handleToggle(item.id) }}>
                            <ListItemText
                                primary={info(item)}
                                secondary={<div>
                                    <div><i>{item.info[sci ? 'com' : 'sci']}</i></div>
                                    <div><small>{item.info['lifestage_name']}</small></div>
                                </div>} />
                            <Switch
                                edge="end"
                                onChange={() => { handleToggle(item.id) }}
                                checked={list.includes(item.id)}
                            />
                        </ListItem>
                    ))
                    }
                </List>
            </DialogContent>
        </Dialog>
    )
};

export default ListEditor;
